import { defineMessages } from 'react-intl';

/** The copy of Your sound (design outreach b1 to b3). */
export const profileMessages = defineMessages({
  title: { id: 'app.outreach.profile.title', defaultMessage: 'Your sound' },
  intro: {
    id: 'app.outreach.profile.intro',
    defaultMessage: 'Every match and every pitch starts here. Change anything; your words win.',
  },
  updated: { id: 'app.outreach.profile.updated', defaultMessage: 'Updated {date}' },
  refresh: { id: 'app.outreach.profile.refresh', defaultMessage: 'Build it again' },
  saving: { id: 'app.outreach.profile.saving', defaultMessage: 'Saving…' },
  saveFailed: { id: 'app.outreach.profile.saveFailed', defaultMessage: 'We could not save this change. Try again.' },

  noProfileTitle: { id: 'app.outreach.profile.none.title', defaultMessage: 'No sound profile yet' },
  noProfileBody: {
    id: 'app.outreach.profile.none.body',
    defaultMessage: 'Plug reads your playlists, your genres and your new song. It takes about 20 seconds.',
  },

  genresTitle: { id: 'app.outreach.profile.genres.title', defaultMessage: 'Genres and moods' },
  genresMeta: { id: 'app.outreach.profile.genres.meta', defaultMessage: 'Matches use the first 3 genres' },
  addGenre: { id: 'app.outreach.profile.genres.add', defaultMessage: '+ Add a genre' },
  addMood: { id: 'app.outreach.profile.moods.add', defaultMessage: '+ Add a mood' },
  remove: { id: 'app.outreach.profile.remove', defaultMessage: 'Remove {name}' },
  tempo: { id: 'app.outreach.profile.tempo', defaultMessage: 'Tempo: {band}' },
  tempoSlow: { id: 'app.outreach.profile.tempo.slow', defaultMessage: 'slow' },
  tempoMid: { id: 'app.outreach.profile.tempo.mid', defaultMessage: 'mid' },
  tempoFast: { id: 'app.outreach.profile.tempo.fast', defaultMessage: 'fast' },

  similarTitle: { id: 'app.outreach.profile.similar.title', defaultMessage: 'You sound like' },
  similarMeta: {
    id: 'app.outreach.profile.similar.meta',
    defaultMessage: '{count, plural, one {# artist} other {# artists}}',
  },
  sourceCooccurrence: {
    id: 'app.outreach.profile.similar.source.cooccurrence',
    defaultMessage: '{count, plural, one {Shares # playlist} other {Shares # playlists}}',
  },
  sourceCooccurrenceNoCount: {
    id: 'app.outreach.profile.similar.source.cooccurrenceNoCount',
    defaultMessage: 'Shares playlists',
  },
  sourceGenre: { id: 'app.outreach.profile.similar.source.genre', defaultMessage: 'Same genre' },
  sourceUser: { id: 'app.outreach.profile.similar.source.user', defaultMessage: 'You added' },
  sourceAi: { id: 'app.outreach.profile.similar.source.ai', defaultMessage: 'Suggested by Plug · checked' },
  noSimilar: {
    id: 'app.outreach.profile.similar.none',
    defaultMessage:
      'None of your songs is on a playlist we track yet, so we cannot see who you sit next to. Name 3 artists you sound like: it is the most important input for the matches.',
  },
  searchPlaceholder: { id: 'app.outreach.profile.similar.search', defaultMessage: 'Search an artist you sound like' },
  add: { id: 'app.outreach.profile.similar.addButton', defaultMessage: 'Add' },
  noHits: { id: 'app.outreach.profile.similar.noHits', defaultMessage: 'No artist found with this name.' },

  marketsTitle: { id: 'app.outreach.profile.markets.title', defaultMessage: 'Where your listeners are' },
  marketsBody: {
    id: 'app.outreach.profile.markets.body',
    defaultMessage: 'Plug adds local playlists, blogs and radio of these countries. Add a country you want to grow in.',
  },
  addCountry: { id: 'app.outreach.profile.markets.add', defaultMessage: 'Add a country (2 letters, for example DE)' },
  noMarkets: {
    id: 'app.outreach.profile.markets.none',
    defaultMessage: 'No country yet. Connect Spotify for Artists in Catalog to see this.',
  },

  sizeTitle: { id: 'app.outreach.profile.size.title', defaultMessage: 'Your size' },
  tierEmerging: { id: 'app.outreach.profile.size.emerging', defaultMessage: 'Emerging' },
  tierDeveloping: { id: 'app.outreach.profile.size.developing', defaultMessage: 'Developing' },
  tierMid: { id: 'app.outreach.profile.size.mid', defaultMessage: 'Mid' },
  tierEstablished: { id: 'app.outreach.profile.size.established', defaultMessage: 'Established' },
  sizeBody: {
    id: 'app.outreach.profile.size.body',
    defaultMessage:
      'Plug pitches playlists of your size first. Big curators rarely answer a new artist, and small ones grow with you.',
  },

  storyTitle: { id: 'app.outreach.profile.story.title', defaultMessage: 'Bio and the story of the song' },
  storyChip: { id: 'app.outreach.profile.story.chip', defaultMessage: 'Plug · from your facts' },
  bioLabel: { id: 'app.outreach.profile.story.bio', defaultMessage: 'Bio' },
  storyLabel: { id: 'app.outreach.profile.story.story', defaultMessage: 'The story of {song}' },
  storyHint: {
    id: 'app.outreach.profile.story.hint',
    defaultMessage: 'Pitches use one or two lines from here. Plug never adds a fact you did not give.',
  },
  voiceLabel: {
    id: 'app.outreach.profile.story.voice',
    defaultMessage: 'Your voice: paste one email or caption you wrote',
  },
  voiceHint: {
    id: 'app.outreach.profile.story.voiceHint',
    defaultMessage: 'The pitches copy your tone, not your words.',
  },
  aiAssisted: { id: 'app.outreach.profile.story.aiAssisted', defaultMessage: 'My songs are made with AI help' },
  aiAssistedHint: {
    id: 'app.outreach.profile.story.aiAssistedHint',
    defaultMessage: 'The pitch page then says "AI-assisted". Curators value the honesty.',
  },

  senderTitle: { id: 'app.outreach.profile.sender.title', defaultMessage: 'How your pitches end' },
  senderName: { id: 'app.outreach.profile.sender.name', defaultMessage: 'From name' },
  senderPostal: {
    id: 'app.outreach.profile.sender.postal',
    defaultMessage: 'Postal address (optional, some countries need it)',
  },
  signature: { id: 'app.outreach.profile.sender.signature', defaultMessage: 'Signature' },
  footerNote: {
    id: 'app.outreach.profile.sender.footer',
    defaultMessage: 'Every email ends with one line: "Sent with MUSIC24 for {name}. Not interested? Reply stop."',
  },
});
